var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterFunnelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5217 6.62952H6.47767C6.11013 6.62952 5.88061 7.03005 6.06513 7.34958L9.55445 13.4311V16.8905C9.55445 17.156 9.76747 17.3705 10.0315 17.3705H13.9679C14.2319 17.3705 14.4449 17.156 14.4449 16.8905V13.4311L17.9357 7.34958C18.1187 7.03005 17.8892 6.62952 17.5217 6.62952ZM13.3708 16.2904H10.6285V14.0702H13.3723V16.2904H13.3708ZM13.5148 12.8911L13.3888 13.1101H10.609L10.483 12.8911L9.33543 10.8899H14.6639L13.5148 12.8911ZM15.2145 9.92982H8.78488L7.50976 7.70962H16.4896L15.2145 9.92982Z",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFunnelIcon);
export default __webpack_public_path__ + "static/media/FilterFunnelIcon.7b8f689f0315beb3c307ac48ccf5cd78.svg";
export { ForwardRef as ReactComponent };